import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BLOG } from '@/constants/testIds';

export function BlogCard({ post }) {
    return (
        <Link
            to={`/blog/${post.slug}`}
            data-testid={BLOG.cardLink(post.slug)}
            className="group block"
        >
            <Card className="overflow-hidden border border-border/80 bg-white rounded-xl transition-[box-shadow,border-color] duration-200 hover:border-slate-300 hover:shadow-[0_1px_0_rgba(15,23,42,0.04),0_16px_40px_rgba(15,23,42,0.08)]">
                <div className="aspect-[16/9] bg-slate-100 overflow-hidden">
                    {post.hero_image ? (
                        <img
                            src={post.hero_image}
                            alt={post.title}
                            width={800}
                            height={450}
                            loading="lazy"
                            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
                        />
                    ) : null}
                </div>
                <div className="p-5">
                    <div className="flex items-center gap-2">
                        <Badge variant="secondary" className="bg-[hsl(var(--accent))] text-[hsl(var(--primary))] hover:bg-[hsl(var(--accent))]">
                            {post.category}
                        </Badge>
                        <span className="text-xs text-slate-500">
                            {new Date(post.published_at).toLocaleDateString(undefined, {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                            })}
                        </span>
                    </div>
                    <h3 className="mt-2 text-lg font-semibold text-slate-900 tracking-tight leading-snug">
                        {post.title}
                    </h3>
                    <p className="mt-2 text-sm text-slate-600 line-clamp-2">{post.excerpt}</p>
                    <div className="mt-3 text-xs text-slate-500">
                        {post.author} · {post.reading_minutes} min read
                    </div>
                </div>
            </Card>
        </Link>
    );
}
